<template>
  <TemplateView>
    <div class="container">
      <TemplatePageGrid
        :items="employeeRolesGrid"
        :page-data="pageData"
        :loading="loadingAnimation"
      >
        <template v-slot:buttons>
          <EmployeeRolesModal
            v-if="
              $userCheckAccess({
                abilities: 'edit_work_roles',
              })
            "
            :create="true"
          />
        </template>
        <EmployeeRolesTable :items="employeeRolesGrid" />
      </TemplatePageGrid>
    </div>
  </TemplateView>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import TemplateView from 'components/templates/TemplateView'
import TemplatePageGrid from 'components/templates/TemplatePageGrid'
import EmployeeRolesTable from 'components/setting/employeeRoles/EmployeeRolesTable'
import EmployeeRolesModal from 'components/setting/employeeRoles/EmployeeRolesModal'

export default {
  name: 'EmployeeRoles',
  components: {
    TemplateView,
    TemplatePageGrid,
    EmployeeRolesTable,
    EmployeeRolesModal,
  },
  data() {
    return {}
  },
  created() {
    this.downloadPageData()
  },
  watch: {
    '$route.query'() {
      this.downloadPageData()
    },
  },
  computed: {
    ...mapGetters('employeeRoles', ['employeeRolesGrid', 'pageData']),
    ...mapGetters(['loadingAnimation']),
  },
  methods: {
    ...mapActions('employeeRoles', ['onEmployeeRolesGrid']),
    downloadPageData() {
      let data = {
        limit: this.$route.query.limit,
        page: this.$route.query.page,
      }
      if (this.$route.query.sort_param && this.$route.query.sort_value) {
        data.sort = {
          param: this.$route.query.sort_param,
          value: this.$route.query.sort_value,
        }
      }
      if (this.$route.query.search) {
        data.search = this.$route.query.search
      }
      this.onEmployeeRolesGrid(data)
    },
  },
}
</script>
